import { isProduction } from '@common/lib/env';
import { getMasterDataThunk } from '@console/actions/thunks/getMasterData';
import { connect } from 'react-redux';
import {
  initializeSnackbarMessage,
  updateIsLoggedIn
} from '../actions/actions';
import { getLoginUserThunk } from '../actions/thunks/getLoginUser';
import type { AppThunkAction, AppThunkDispatch } from '../actions/thunkType';
import { getG4bMyPageAccountLoginUrl } from '../common/g4bMyPage';
import App from '../components/App';
import type { AppState } from '../reducers';

const getInitialData = (): AppThunkAction<Promise<void>> => dispatch =>
  dispatch(getLoginUserThunk())
    .then(() => {
      dispatch(updateIsLoggedIn(true));
    })
    .catch(() => {
      window.location.href = getG4bMyPageAccountLoginUrl(
        !isProduction ? window.location.href : undefined
      );
    })
    .then(() => dispatch(getMasterDataThunk()).catch(() => {}));

const handleClose = (): AppThunkAction<void> => dispatch => {
  dispatch(initializeSnackbarMessage());
};

const mapStateToProps = (state: AppState) => ({
  isLoggedIn: state.isLoggedIn,
  isLoading: state.loaders.isAppLoading,
  snackbarMessage: state.snackbarMessage,
  distributionPartnerUser: state.distributionPartnerUser
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  getInitialData: () => dispatch(getInitialData()),
  handleClose: () => dispatch(handleClose())
});

export type AppPropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type AppPropsMappedFromDispatch = ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(App);
